import { gql } from '@apollo/client';

export  const updateListing = `query (
  $id: Int,
  $roomType:String,
  $houseType:String,
  $residenceType:String,
  $bedrooms:String,
  $buildingSize:String,
  $beds:Int,
  $personCapacity:Int,
  $bathrooms:Float,
  $bathroomType:String,
  $country:String,
  $street:String,
  $buildingName:String,
  $city:String,
  $state:String,
  $zipcode:String,
  $lat: Float,
  $lng: Float,
  $isMapTouched: Boolean,
  $amenities: [Int],
  $safetyAmenities: [Int],
  $spaces: [Int],
  $bedTypes: String,
  $rooms: String,
) {
    updateListing (
      id: $id,
      roomType:$roomType,
      houseType:$houseType,
      residenceType: $residenceType,
      bedrooms: $bedrooms,
      buildingSize: $buildingSize
      beds: $beds
      personCapacity: $personCapacity
      bathrooms: $bathrooms
      bathroomType: $bathroomType
      country: $country
      street: $street
      buildingName: $buildingName
      city: $city
      state: $state
      zipcode: $zipcode
      lat: $lat
      lng: $lng
      isMapTouched: $isMapTouched,
      amenities: $amenities,
      safetyAmenities: $safetyAmenities,
      spaces: $spaces,
      bedTypes: $bedTypes,
      rooms: $rooms,
    ) {
      status
    }
  }`;

export const updateListingStep2 = `query (
  $id: Int,
  $description: String,
  $title: String,
  $coverPhoto: Int
) {
    updateListingStep2 (
      id: $id,
      description: $description,
      title: $title,
      coverPhoto: $coverPhoto
    ) {
      status
    }
  }`;

export const updateListingStep3 = `query (
    $id: Int,
  $houseRules: [Int],
  $additionalRules: String,
  $bookingNoticeTime:String,
  $checkInStart:String,
  $checkInEnd:String,
  $maxDaysNotice:String,
  $minNight:Int,
  $maxNight:Int,
  $basePrice:Float,
  $weekendPrice:Float,
  $minStayWeekend:Boolean,
  $cleaningPrice:Float,
  $tax:Float,
  $currency:String,
  $weeklyDiscount:Float,
  $monthlyDiscount:Float,
  $blockedDates: [String],
  $bookingType: String!,
  $cancellationPolicy: Int,
  $extraGuestThreshold: Int,
  $extraGuestFee: Float,
  $cautionDeposit: Float,
  $customDiscounts: String,
) {
    updateListingStep3 (
      id: $id,
      houseRules: $houseRules,
      additionalRules: $additionalRules,
      bookingNoticeTime:$bookingNoticeTime,
      checkInStart:$checkInStart,
      checkInEnd:$checkInEnd,
      maxDaysNotice:$maxDaysNotice,
      minNight:$minNight,
      maxNight:$maxNight,
      basePrice:$basePrice,
      weekendPrice:$weekendPrice,
      minStayWeekend:$minStayWeekend,
      cleaningPrice:$cleaningPrice,
      tax:$tax,
      currency:$currency,
      weeklyDiscount:$weeklyDiscount,
      monthlyDiscount:$monthlyDiscount,
      blockedDates: $blockedDates,
      bookingType: $bookingType,
      cancellationPolicy: $cancellationPolicy,
      extraGuestThreshold: $extraGuestThreshold,
      extraGuestFee: $extraGuestFee,
      cautionDeposit: $cautionDeposit,
      customDiscounts: $customDiscounts
    ) {
      status
    }
  }`;

export const getListingSettingsQuery = gql`
    query($step: String){
      getListingSettings(step: $step) {
        id
        typeName
        fieldType
        typeLabel
        step
        isEnable
        isMultiValue
        listSettings {
          id
          typeId
          itemName
          otherItemName
          maximum
          minimum
          startValue
          endValue
          isEnable
          image
        }
      }
    }
    `;

export const showListingSteps = gql`
    query ($listId:String!) {
      showListingSteps (listId:$listId) {
        id
        listId
        step1
        step2
        step3
        step4
        listing {
          id
          isReady
          isPublished
          listApprovalStatus
          user {
            id
            email
            userBanStatus
            userDeletedAt
          }
        }
      }
    }
    `;

export const RemoveListing = gql`
    mutation RemoveListing($listId:Int!) {
      RemoveListing (listId:$listId) {
        status
        id
        name
      }
    }
    `;

export const UpdateListViews = gql`
    mutation UpdateListViews($listId: Int!){
        UpdateListViews(listId: $listId) {
            status
        }
    }
    `;

export const addRecommendMutation = gql`
    mutation addRecommend($listId: Int){
      addRecommend(listId: $listId) {
        id
        listId
        status
        errorMessage
      }
    }
    `;

export const removeRecommendMutation = gql`
    mutation removeRecommend($listId: Int){
      removeRecommend(listId: $listId) {
        listId
        status
        errorMessage
      }
    }
    `;

export const adminRemoveListing = gql`
    mutation adminRemoveListing($listId:Int!) {
      adminRemoveListing (listId:$listId) {
        status
        id
        name
      }
    }
    `;
    
